import { Pipe, PipeTransform } from '@angular/core';
import { ResultDu } from '../../entity/result-du';

@Pipe({name: 'sort_results_filter'})
export class SortResultsFilterPipe implements PipeTransform {
    transform(items: ResultDu[]): any {
        if (!items) {
            return items;
        }
        // sort items array bu du code
        return items.sort((a,b)=>a.du.solutionCode.localeCompare(b.du.solutionCode));
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/sort-results.pipe.ts